// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ingredient-reviews .tabler-icon.tabler-icon-chevrons-down,
.ingredient-reviews .tabler-icon.tabler-icon-chevron-down {
  color: #495057;
}
.ingredient-reviews .tabler-icon.tabler-icon-chevrons-down[style*="rotate(-180deg)"],
.ingredient-reviews .tabler-icon.tabler-icon-chevron-down[style*="rotate(-180deg)"] {
  color: #00889b;
}
.ingredient-reviews .mantine-TableBodyCell-DetailPanel {
  background-color: #b9cbcb;
}
.ingredient-reviews .ingredient-sub-panel td {
  padding: 0 0.625rem;
}
.ingredient-reviews .ingredient-suggestion-table {
  background-color: "#eef8f8";
  border: solid 1px #a9a9ab;
  border-radius: 5;
  margin: 8px 0;
  max-height: 300;
  overflow-y: auto;
  padding: 8px 0;
  width: 100%;
}
.ingredient-reviews .selected-ingredients-count {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2em;
  height: 2em;
  border-radius: 50%;
  background-color: #00889b;
  color: #fff;
  font-size: 1rem;
  font-weight: bold;
  border: 2px solid #fff;
}`, "",{"version":3,"sources":["webpack://./src/pages/ingredient-review/IngredientsReview.scss"],"names":[],"mappings":"AAEE;;EAEE,cAAA;AADJ;AAGI;;EACE,cAAA;AAAN;AAIE;EACE,yBAAA;AAFJ;AAMI;EACE,mBAAA;AAJN;AAQE;EACE,2BAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;AANJ;AASE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAPJ","sourcesContent":["\n.ingredient-reviews {\n  .tabler-icon.tabler-icon-chevrons-down,\n  .tabler-icon.tabler-icon-chevron-down {\n    color: #495057;\n\n    &[style*='rotate(-180deg)'] {\n      color: #00889b;\n    }\n  }\n\n  .mantine-TableBodyCell-DetailPanel {\n    background-color: #b9cbcb;\n  }\n\n  .ingredient-sub-panel {\n    td {\n      padding: 0 .625rem;\n    }\n  }\n\n  .ingredient-suggestion-table {\n    background-color: '#eef8f8';\n    border: solid 1px #a9a9ab;\n    border-radius: 5;\n    margin: 8px 0;\n    max-height: 300;\n    overflow-y: auto;\n    padding: 8px 0;\n    width: 100%;\n  }\n\n  .selected-ingredients-count {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 2em;\n    height: 2em;\n    border-radius: 50%;\n    background-color: #00889b;\n    color: #fff;\n    font-size: 1rem;\n    font-weight: bold;\n    border: 2px solid #fff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
